import { z } from 'zod';

export const NAME_MAX_LENGTH = 50;

// Имя — только буквы (любой алфавит), пробел, дефис и апостроф: "Абдулла",
// "Anna-Maria", "G‘ulom". Цифры и спецсимволы бэк принимает молча, поэтому
// режем их на клиенте.
const NAME_PATTERN = /^[\p{L}\s'’-]+$/u;

/**
 * Убирает недопустимые символы прямо при вводе — и при наборе, и при вставке
 * из буфера, чтобы пользователь не упирался в ошибку уже на кнопке.
 * Пробел в начале тоже не пропускаем: имя с него не начинается.
 */
export const sanitizeName = (value: string) =>
  value.replace(/[^\p{L}\s'’-]/gu, '').replace(/^\s+/, '');

// Сообщения — ключи i18n: FormMessage прогоняет error.message через t().
// Без min(1) пустая строка проходила валидацию и затирала имя на аккаунте.
export const nameValueSchema = z
  .string()
  .trim()
  .min(1, 'validation.name')
  .max(NAME_MAX_LENGTH, 'validation.name-length')
  .regex(NAME_PATTERN, 'validation.name-chars');
